<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="dataRight">
        <div class="stateTable">
          <el-scrollbar>
            <div class="echart-title">
              <div class="title-name">{{$t('GovernmentRegulation.overview')}}</div>
              <el-row :gutter="20" class="title-content">
                <div v-for="(title, index) in titles" :key="index" @click="btnTitle(title)">
                  <div class="content-one">
                      <div :class="line[index]"></div>
                      <div>
                        <div :class="oneDown[index]">
                          {{ title.count | NumFormat }}
                        </div>
                        <div class="one-up" :class="oneUp[index]">{{ title.showName }}</div>
                      </div>
                    </div>
                </div>
              </el-row>
            </div>
            <div class="echart-one">
              <div class="oneEchart">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <div class="echartTitle">{{$t('GovernmentRegulation.emissionRatio')}}</div>
                    <linegraph
                      :id="'emissionPie'"
                      :data="emissionOption"
                      style="height: 300px; border-right: 1px solid #adb1c3"
                    ></linegraph>
                  </el-col>
                  <el-col :span="8">
                    <div class="echartTitle">{{$t('GovernmentRegulation.safeEquiteRatio')}}</div>
                    <linegraph
                      :id="'securePie'"
                      :data="secureOption"
                      style="height: 300px; border-right: 1px solid #adb1c3"
                    ></linegraph>
                  </el-col>
                  <el-col :span="8">
                    <div class="echartTitle">{{$t('GovernmentRegulation.carAgeRatio')}}</div>
                    <div>
                      <linegraph
                        :id="'agePie'"
                        :data="ageOption"
                        style="height: 300px;"
                      ></linegraph>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="echart-one">
              <div class="oneEchart">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <div class="echartTitle">{{$t('GovernmentRegulation.maintenanceRatio')}}</div>
                    <linegraph
                      :id="'maintenancePie'"
                      :data="maintenanceOption"
                      style="height: 300px; border-right: 1px solid #adb1c3"
                    ></linegraph>
                  </el-col>
                  <el-col :span="8">
                    <div class="echartTitle">{{$t('GovernmentRegulation.checkRatio')}}</div>
                    <linegraph
                      :id="'checkPie'"
                      :data="checkOption"
                      style="height: 300px; border-right: 1px solid #adb1c3"
                    ></linegraph>
                  </el-col>
                  <el-col :span="8">
                    <div class="echartTitle">{{$t('GovernmentRegulation.checkAbnormalRatio')}}</div>
                    <div>
                      <linegraph
                        :id="'abnormalPie'"
                        :data="abnormalOption"
                        style="height: 300px;"
                      ></linegraph>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="1200px"
        :before-close="closeOperateDia"
        class="tableDialong"
        :title="OperateTitle"
        :visible.sync="dialogOperateFormVisible"
        :close-on-click-modal="false"
      >
        <div class="zMsgBtn">
          <el-button type="text" @click="down">{{$t('common.btn.download')}}</el-button>
        </div>
        <div class="zMsgTable">
          <i-table
            :list="operatesList"
            :height="operatesHeight"
            ref="operatesTable"
            :options="option"
            :columns="allColumns"
            :operates="allOperates"
          ></i-table>
          <IPagination
            ref="OperatesPage"
            @PageFun="changeOperatesSize"
          ></IPagination>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Comprehensive from "./Comprehensive.js";
export default Comprehensive;
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/Style.less";
</style>
